<template>
  <div>
    <vs-alert class="mb-base" active="true" color="warning" icon-pack="feather" icon="icon-alert-triangle" v-if="merchantStatus === 'on_hold'">
      {{$t('Your account is')}} <b>{{$t('On hold')}}</b>. {{$t('Please, contact your account manager to re-activate!')}}
    </vs-alert>
    <div class="flex justify-between">
      <span class="font-semibold"></span>
      <span v-if="$route.name !== 'merchant-cash-collections-view'" class="font-medium text-primary cursor-pointer">
        <vs-dropdown v-if="merchantStatus == 'active'"
          vs-trigger-click
          class="dropdown dd-actions cursor-pointer mr-4 mb-4"
        >
          <vs-button
            color="primary"
            icon-pack="feather"
            icon="icon-plus"
            size="large"
          >
          </vs-button>
          <vs-dropdown-menu class="add-shipment-dropdown">
            <vs-dropdown-item @click="openModal('Add Delivery Order')">
              <span class="flex items-center">
                <feather-icon
                  icon="TruckIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>{{$t('New Delivery Order')}}</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="openModal('Add Return')">
              <span class="flex items-center">
                <feather-icon
                  icon="PackageIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>{{$t('New Return')}}</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="exchangePage()">
              <span class="flex items-center">
                <feather-icon
                  icon="RepeatIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>{{$t('Add new Exchange Request')}}</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="openCashCollectionModal('Add Cash Collection')">
              <span class="flex items-center">
                <feather-icon
                  icon="DollarSignIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>{{$t('New Cash Collection')}}</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="addSupply('add')">
              <span class="flex items-center">
                <feather-icon
                  icon="PackageIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>{{$t('New Supplies Request')}}</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="uploadShipments()">
              <span class="flex items-center">
                <feather-icon
                  icon="UploadIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>{{$t('Upload Multiple Orders')}}</span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </span>
      <span v-else class="font-medium text-primary cursor-pointer">
        <span @click="openCashCollectionModal('Add Cash Collection')" class="font-medium text-primary cursor-pointer">
          <vs-button
            color="primary"
            icon-pack="feather"
            icon="icon-plus"
            size="large"
          >
          </vs-button>
        </span>
      </span>
    </div>
    <add-shipment @loadServicesAvailability="loadServicesAvailability" @orderType="orderType=$event" :governorates="governorates" :cities="cities" :pickupPoints="pickupPoints"
    :packages="packages" :orderPrice="orderPrice" :pudos="pudos" :handShakes="handShakes" :packageSizes="packageSizes" :serviceLevels="serviceLevels" @shipmentModal="shipmentModal = $event"
    :type="type" @selectionInProgress="selectionInProgress = $event" :shipmentModal="shipmentModal" :shipment="shipment" :estimatePrice="estimatePrice" @addShipment="addShipment" @estimatePrice="estimatePrice = $event"></add-shipment>

    <add-cash-collection :governorates="governorates" :type="type" :orderPrice="orderPrice" 
      :cashCollectionModal="cashCollectionModal" @cashCollectionModal="cashCollectionModal = $event" :shipment="shipment" @addCashCollection="addCashCollection"></add-cash-collection>
    <shipblu-prompt
      class="shipment-modal"
      @close="closeShipmentsModal"
      :active.sync="uploadShipmentsModal"
      :title="$t('Upload Delivery Orders')"
      :buttons-hidden="true">
      <div class="text-center mt-5">
        <vs-button><a :href="file_URl" class="text-white">{{$t('Download Template')}}</a></vs-button>
      </div>
      <div class="excel-import">
        <input type="file" ref="fileInput" class="hidden" accept=".xlsx, .xls" @change="handleClick">
        <div
          @click="$refs.fileInput.click()"
          @drop="handleDrop"
          @dragover="handleDragover"
          @dragenter="handleDragover"
          class="w-1/2 m-auto mt-10 mb-10 px-8 py-16 cursor-pointer text-center border-2 border-dashed d-theme-border-grey-light d-theme-dark-bg text-xl">
          <feather-icon icon="UploadCloudIcon" svgClasses="h-16 w-16 stroke-current text-grey" class="block" />
          <span>{{$t('Drop Excel File or')}} </span>
          <span class="font-medium text-primary" @click.stop="$refs.fileInput.click()">{{$t('Browse')}}</span>
        </div>
      </div>
      <div v-if="file" class="w-4/5 m-auto text-center mb-3">
        <vs-progress :percent="progress" color="primary"></vs-progress>
        <p>{{progress}}%</p>
      </div>
    </shipblu-prompt>
    <supply :type="type" :packagesDic="packagesDic" :packagesSize="packagesSize" :data="supply" :supplyModal="supplyModal" @supplyModal="supplyModal = $event"></supply>
  </div>
</template>

<script>
import {sendRequest} from '../../../http/axios/requestHelper.js'
import Supply from './Supply.vue'
import vSelect from 'vue-select'
import i18nData from '../../../i18n/i18nData.js'
import AddCashCollection from './AddCashCollection.vue'
import AddShipment from './AddShipment.vue'
import axios from '../../../axios.js'
import common from '@/assets/utils/common'
import ShipbluPrompt from '../../../layouts/components/ShipBluPrompt.vue'
 
export default {
  data () {
    return {
      releaseVersion: process.env.VUE_APP_RELEASE_VERSION,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
      },
      supplyModal: false,
      merchantUID: this.$store.state.AppActiveUser.uid,
      pickupPoints: [],
      merchantID: '',
      uploadShipmentsModal: false,
      shipmentModal: false,
      selectionInProgress: false,
      cashCollectionModal: false,
      shipmentURL: 'api/v1/delivery-orders/?ref=webapp',
      shipment: {
        customer_city: {
          id: '',
          name: ''
        },
        customer_governorate: {
          id: '',
          name: ''
        },
        address: {
          line_1: '',
          zone: ''
        },
        service_level: {},
        pickupPoint: {}
      },
      packages: [
        {
          package_size: '',
          description: '',
          fragile: false
        }
      ],
      subscriptionId: '',
      serviceLevels: [],
      packageSizes: [
        {
          description: 'Small Flyer (20x25cm)',
          id: 1,
          name: 'Small Flyer (20x25cm)',
          short_code: 'S-FLY'
        },
        {
          description: 'Medium Flyer (40x40cm)',
          id: 2,
          name: 'Medium Flyer (40x40cm)',
          short_code: 'M-FLY'
        },
        {
          description: 'Large Flyer (45x50cm)',
          id: 3,
          name: 'Large Flyer (45x50cm)',
          short_code: 'L-FLY'
        },
        {
          description: 'Extra Large Flyer (50x60cm)',
          id: 4,
          name: 'Extra Large Flyer (50x60cm)',
          short_code: 'XL-FLY'
        }
      ],
      governorates: [],
      cities: [],
      zones: [],
      merchantCashOnDeliveryFees: 0,
      merchantStatus: '',
      packagesSize: [],
      handShakes: [],
      packagesDic: {},
      supply: {},
      type: 'Add Delivery Order',
      estimatePrice: 0,
      file_URl: '',
      pudos: [],
      orderPrice: {},
      progress: 0,
      myProgress: 0,
      closeInterval: 0,
      file: false,
      sucessModal: false,
      merchantName: '',
      merchantEmail: ''
    }
  },
  watch: {
    'shipment.customer_governorate' () {
      if (this.canEstimatePriceDelivery(this.shipment)) {
        this.loadEstimatedPrice()
      }
    },
    'shipment.promoCode' () {
      if (this.canEstimatePriceDelivery(this.shipment)) {
        this.loadEstimatedPrice()
      }
    },
    'shipment.declared_value' () {
      if (this.canEstimatePriceDelivery(this.shipment)) {
        this.loadEstimatedPrice()
      }
    },
    'shipment.cash_amount' () {
      if (this.canEstimatePriceCash(this.shipment) && this.type === 'Add Cash Collection') {
        this.loadEstimatedPrice()
      } else if (this.canEstimatePriceDelivery(this.shipment) && (this.type === 'Add Delivery Order' || this.type === 'Add Return')) {
        this.loadEstimatedPrice()
      }
    },
    'packages': {
      handler () {
        if (this.packages.every(packageItem => packageItem.package_size) && this.canEstimatePriceDelivery(this.shipment) && (this.type === 'Add Delivery Order' || this.type === 'Add Return')) {
          this.loadEstimatedPrice()
        }
      },
      deep: true
    },
    'progress' (val) {
      if (val === 95) {
        clearInterval(this.myProgress)
      }
    }
  },
  methods: {
    closeShipmentsModal () {
      this.uploadShipmentsModal = false
      this.progress = 0
      this.file = false
    },
    loadAvailablePudos (cityID) {
      sendRequest(false, false, this, `api/v1/pudo/cities/${cityID}/`, 'get', null, true, 
        (response) => {
          this.pudos = response.data.results
        }
      )
    },
    canEstimatePriceDelivery (shipment) {
      if (shipment.customer_governorate && this.packages.length > 0 && this.packages.every(packageItem => packageItem.package_size)) {
        return true
      }
    },
    canEstimatePriceCash (shipment) {
      if (shipment.customer_governorate && shipment.cash_amount !== null) {
        return true
      }
    },
    loadEstimatedPrice () {
      let type = ''
      switch (this.type) {
      case 'Add Delivery Order':
        type = 'delivery'
        break
      case 'Add Return':
        type = 'return'
        break
      case 'Add Cash Collection':
        type = 'cash-collection'
        break 
      default:
        break
      }
      const orderData = {
        to_governorate: this.shipment.customer_governorate ? this.shipment.customer_governorate.id : ''
      }
      if (type === 'return') {
        this.shipmentURL = 'api/v1/returns/'
        orderData.cash_amount = this.shipment.cash_amount ? Number(this.shipment.cash_amount) : 0
      } else if (type === 'delivery') {
        orderData.cash_amount = this.shipment.cash_amount ? Number(this.shipment.cash_amount) : 0
        orderData.declared_value = this.shipment.declared_value
        orderData.is_customer_allowed_to_open_packages = this.shipment.is_customer_allowed_to_open_packages === 'Can Open'
      } else {
        orderData.amount = this.shipment.cash_amount ? Number(this.shipment.cash_amount) : 0
      }
      this.$vs.loading.close()
      orderData.packages = []
      if (type === 'delivery' || type === 'return') {
        orderData.packages = this.packages.map(item => item.package_size.id)
      }
      orderData.discount_code = this.shipment.promoCode
      sendRequest(false, false, this, `api/v1/pricing/orders/${type}/`, 'post', orderData, true,
        (response) => {
          this.orderPrice = response.data
        }
      )
    },
    loadServicesAvailability (id) {
      sendRequest(false, false, this, `api/v1/services-availability/?governorate_id=${id}&subscription_id=${this.subscriptionId}`, 'get', null, true, 
        (response) => {
          const serviceLevels = response.data.map(element => element.service_level)
          const handShakes = response.data.map(element => element.handshake_type)
          const key = 'id'

          this.serviceLevels = [...new Map(serviceLevels.map(item => [item[key], item])).values()]
          this.serviceLevels = this.serviceLevels.reverse()
          this.handShakes = [...new Map(handShakes.map(item => [item[key], item])).values()]
          this.shipment.handShakeType = this.handShakes[0].id
        }
      )
    },
    addSupply (type) {
      this.type = type
      this.supply = Object.assign({}, {})
      this.shipmentModal = false
      this.cashCollectionModal = false
      this.uploadShipmentsModal = false
      this.supplyModal = true
    },
    loadPackagesSize () {
      sendRequest(false, false, this, 'api/v1/package-sizes/', 'get', null, true, 
        (response) => {
          const data = response.data
          const time = new Date()
          const PackageSizesDataTime = {data, time}
          localStorage.setItem('packages', JSON.stringify(PackageSizesDataTime))
          this.managePackageSize(response.data)
        }
      )
    },
    managePackageSize (packages) {
      this.packagesSize = packages
      this.packagesSize = this.packagesSize.slice(0, 5)
      this.packagesSize.forEach(packageSize => {
        this.packagesDic[packageSize.id] = packageSize.short_code
      })
    },
    loadMerchant () {
      sendRequest(false, false, this, `api/v1/users/merchants/${this.merchantUID}/`, 'get', null, true, 
        (response) => {
          localStorage.setItem('userMerchant', JSON.stringify(response.data))
          this.merchantID = response.data.merchant
          this.merchantEmail = response.data.email
          this.loadMerchantData()
        }
      )
    },
    loadMerchantData () {
      sendRequest(false, false, this, `api/v1/merchants/${this.merchantID}/`, 'get', null, true, 
        (response) => {
          localStorage.setItem('merchant', JSON.stringify(response.data))
          this.merchantStatus = response.data.status
          this.merchantName = response.data.name
          this.merchantCashOnDeliveryFees = response.data.cash_processing_fees
          this.subscriptionId = response.data.subscription.id
          if (this.merchantStatus === 'active') {
            this.loadPickupPoints()
          }
        }
      )
    },
    loadPickupPoints () {
      sendRequest(true, false, this, `api/v1/merchants/${this.merchantID}/pickup-points/`, 'get', null, true, 
        (response) => {
          this.pickupPoints = response.data.results
          this.pickupPoints.forEach(element => {
            element.fullAddress = element.address.line_1 + element.address.line_2 + element.address.zone.name
            if (element.is_default) {
              this.pickupPoint = element
            }
          })
        }
      )
    },
    loadGovernorates () {
      sendRequest(false, false, this, 'api/v1/governorates/', 'get', null, true, 
        (response) => {
          this.governorates = response.data
          this.governorates = response.data.filter(item => item.id !== 11 && item.id !== 12 && item.id !== 20 && item.id !== 21 && item.id !== 22 && item.id !== 23)
        }
      )
    },
    getTemplate () {
      sendRequest(false, false, this, 'api/v1/orders-upload/', 'get', null, true, 
        (response) => {
          this.file_URl = response.data.file_url
        }
      )
    },
    openModal (type) {
      if (this.releaseVersion !== 'staging') {
        this.$mixpanel.track(this.type === 'Add Return' ? 'New Return' : 'New Delivery Order', {
          merchant_name: this.merchantName,
          merchant_email: this.merchantEmail,
          source: /(android)/i.test(navigator.userAgent)
        })
      }
      this.type = type
      this.orderPrice = {}
      this.serviceLevels = []
      this.handShakes = []
      this.loadGovernorates()
      this.cities = []
      this.zones = []
      this.pudos = []
      this.shipment = {
        phone: '',
        cash_amount: 0,
        is_customer_allowed_to_open_packages: false,
        subscriptionId: this.subscriptionId,
        pickupPoint: this.pickupPoint,
        is_counter_dropoff: {
          id: 2,
          name: 'Pickup'
        },
        declared_value: 0,
        serviceLevel: {},
        address: {
          line_1: '',
          zone: ''
        }
      }
      this.packages = []
      this.cashCollectionModal = false
      this.shipmentModal = true
    },
    openCashCollectionModal (type) {
      this.type = type
      this.orderPrice = {}
      this.loadGovernorates()
      this.cities = []
      this.zones = []
      this.shipment = {
        cash_amount: 0,
        address: {
          line_1: '',
          zone: ''
        }
      }
      this.shipmentModal = false
      this.cashCollectionModal = true
    },
    uploadShipments () {
      this.getTemplate()
      this.shipmentModal = false
      this.cashCollectionModal = false
      clearInterval(this.closeInterval)
      this.uploadShipmentsModal = true
    },
    addShipment () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const orderData = {
            is_pudo: this.shipment.handShakeType === 2,
            customer: {
              full_name: this.shipment.full_name,
              phone: this.shipment.phone,
              secondary_phone: this.shipment.secondary_phone
            },
            is_counter_dropoff: this.shipment.is_counter_dropoff === 1,
            service_level: this.subscriptionId === 2 ? this.serviceLevels[0].id : this.shipment.serviceLevel.id,
            pickup_point: this.shipment.pickupPoint ? this.shipment.pickupPoint.id : '',
            merchant_order_reference: this.shipment.merchant_order_reference,
            preferred_date: this.shipment.preferred_date,
            is_customer_allowed_to_open_packages: this.shipment.is_customer_allowed_to_open_packages === 'Can Open'
          }
          if (orderData.is_pudo) {
            orderData.customer.address = {
              id: this.shipment.pudo.address.id,
              google_maps_link: this.shipment.pudo.address.google_maps_link,
              line_1: this.shipment.pudo.address.line_1,
              line_2: this.shipment.pudo.address.line_2,
              line_3: this.shipment.pudo.address.line_3,
              zone: this.shipment.pudo.address.zone.id,
              zip_code: this.shipment.pudo.address.zip_code
            }
          } else {
            orderData.customer.address = {
              line_1: this.shipment.address.line_1,
              line_2: this.shipment.address.line_2,
              line_3: this.shipment.address.line_3,
              zone: this.shipment.address.customerZone.id,
              zip_code: this.shipment.customer_zip_code,
              what3words: this.shipment.address.what3words ? this.shipment.address.what3words : null
            }
          }
          if (this.type === 'Add Return') {
            this.shipmentURL = 'api/v1/returns/?ref=webapp'
            orderData.service_level = this.shipment.serviceLevel.id
            orderData.cash_amount = Number(this.shipment.cash_amount)
          } else {
            orderData.declared_value = Number(this.shipment.declared_value)
            orderData.cash_amount = Number(this.shipment.cash_amount)
          }
          orderData.packages = []
          this.packages.forEach(element => {
            orderData.packages.push({
              package_size: element.package_size.id,
              description: element.description,
              fragile: element.fragile
            })
          })
          if (this.shipment.email !== '') {
            orderData.customer.email = this.shipment.email
          }
          if (this.shipment.order_notes !== null && this.shipment.order_notes !== '') {
            orderData.order_notes = this.shipment.order_notes
          }
          orderData.cash_on_delivery_fees = this.merchantCashOnDeliveryFees
          orderData.discount_code = this.shipment.promoCode
          if (!this.isOnline) this.shipmentModal = false
          sendRequest(false, false, this, this.shipmentURL, 'post', orderData, true,
            () => {
              if (this.releaseVersion !== 'staging') {
                this.$mixpanel.track(this.type === 'Add Return' ? 'Complete New Return' : 'Complete New Delivery Order', {
                  merchant_name: this.merchantName,
                  merchant_email: this.merchantEmail,
                  source: /(android)/i.test(navigator.userAgent)
                })
              }

              // MIXPANEL
              if (!this.selectionInProgress) {
                if (this.releaseVersion !== 'staging') {
                  this.$mixpanel.track('RECURRING_CUSTOMER', {
                    merchant_name: this.merchantName,
                    merchant_email: this.merchantEmail,
                    source: /(android)/i.test(navigator.userAgent)
                  })
                }
              }
              if (this.shipment.address.what3words) {
                if (this.releaseVersion !== 'staging') {
                  this.$mixpanel.track('W3W_ORDER_CREATION', {
                    merchant_name: this.merchantName,
                    merchant_email: this.merchantEmail,
                    source: /(android)/i.test(navigator.userAgent)
                  })
                }
              }
              this.shipmentModal = false
              this.$vs.notify({
                color:'success',
                title:i18nData[this.$i18n.locale]['Success'],
                text:this.type === 'Add Delivery Order' ? i18nData[this.$i18n.locale]['Delivery Order'] + i18nData[this.$i18n.locale][' has been created successfully!'] : i18nData[this.$i18n.locale]['Return'] + i18nData[this.$i18n.locale][' has been created successfully!'],
                position: 'top-center'
              })
              this.shipmentModal = false
              if (this.type === 'Add Delivery Order') {
                if (this.$route.name === 'merchant-shipments') {
                  this.$emit('loadShipments')
                } else {
                  this.$router.push({
                    name: 'merchant-shipments'
                  })
                }
              } else if (this.type === 'Add Return') {
                if (this.$route.name === 'merchant-returns-view') {
                  this.$emit('loadShipments')
                } else {
                  this.$router.push({
                    name: 'merchant-returns-view'
                  })
                }
              }
            }
          )
        }
      })
    },
    addCashCollection () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const cashCollectionData = {
            customer: {
              full_name: this.shipment.full_name,
              phone: this.shipment.phone,
              email: this.shipment.email,
              secondary_phone: this.shipment.secondary_phone,
              address: {
                line_1: this.shipment.address.line_1,
                line_2: this.shipment.address.line_2,
                zone: this.shipment.address.customerZone.id,
                what3words: this.shipment.address.what3words
              }
            },
            amount: this.shipment.cash_amount
          }
          if (!this.isOnline) this.cashCollectionModal = false
          sendRequest(false, false, this, 'api/v1/cash-collections/', 'post', cashCollectionData, true,
            () => {
              this.$vs.notify({
                color:'success',
                title:i18nData[this.$i18n.locale]['Success'],
                text: i18nData[this.$i18n.locale]['Cash Collection'] + i18nData[this.$i18n.locale][' has been created successfully!'],
                position: 'top-center'
              })
              this.cashCollectionModal = false

              if (this.$route.name === 'merchant-cash-collections-view') {
                this.$emit('loadShipments')
              } else {
                this.$router.push({
                  name: 'merchant-cash-collections-view'
                })
              }
            }
          )
        }
      })
    },
    uploadFile (file) {
      if (this.releaseVersion !== 'staging') {
        this.$mixpanel.track('Upload Excel sheet', {
          merchant_name: this.merchantName,
          merchant_email: this.merchantEmail,
          source: /(android)/i.test(navigator.userAgent)
        })
      }
      if (!this.isExcel(file)) {
        this.$vs.notify({
          color: 'warning',
          title: i18nData[this.$i18n.locale]['Warning'],
          text: 'Only supports upload .xlsx, .xls, .csv suffix files',
          position: 'top-center'
        })
        return false
      }
      this.$refs['fileInput'].value = null // fix can't select the same excel
      this.progress = 0
      this.file = true
      const formData = new FormData()
      formData.append('orders', file)
      if (!this.isOnline) this.uploadShipmentsModal = false
      this.myProgress = setInterval(() => {
        this.progress += 1
      }, 500)
      this.headers = {
        ...this.headers,
        'Accept-Language': this.$i18n.locale
      }
      axios.post('api/v1/orders-upload/', formData, {headers: this.headers})
        .then((response) => {
          this.progress = 100
          clearInterval(this.myProgress)
          this.$vs.notify({
            color:'success',
            title:i18nData[this.$i18n.locale]['Success'],
            text: response.data.message,
            position: 'top-center'
          })
          this.$emit('loadShipments')
          this.closeInterval = setInterval(() => {
            this.uploadShipmentsModal = false
            this.file = false
          }, 700)
        })
        .catch((error) => {
          this.progress = 100
          clearInterval(this.myProgress)
          common.notifyResponseError(this, error)
        })
    },
    handleClick (e) {
      const files = e.target.files
      const rawFile = files[0]
      if (!rawFile) return
      this.uploadFile(rawFile)
    },
    handleDragover (e) {
      e.stopPropagation()
      e.preventDefault()
      e.dataTransfer.dropEffect = 'copy'
    },
    handleDrop (e) {
      e.stopPropagation()
      e.preventDefault()
      const files = e.dataTransfer.files
      if (files.length !== 1) {
        this.$vs.notify({
          title: 'Login Attempt',
          text: 'Only support uploading one file!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return
      }
      const rawFile = files[0] // only use files[0]
      if (!this.isExcel(rawFile)) {
        this.$vs.notify({
          title: 'Login Attempt',
          text: 'Only supports upload .xlsx, .xls, .csv suffix files',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.uploadFile(rawFile)
    },
    isExcel (file) {
      return /\.(xlsx|xls|csv)$/.test(file.name)
    },
    exchangePage () {
      this.$router.push({
        name: 'merchant-shipments',
        query: {
          page: 1,
          filter: 'delivered',
          from: 'exchange'
        } 
      }).catch(() => {})
    }
  },
  components: {
    Supply,
    vSelect,
    AddShipment,
    AddCashCollection,
    ShipbluPrompt
  },
  created () {
    if (JSON.parse(localStorage.getItem('userMerchant')) === null) {
      this.loadMerchant()
    } else if (JSON.parse(localStorage.getItem('merchant') === null)) {
      const userMerchant = JSON.parse(localStorage.getItem('userMerchant'))
      this.merchantID = userMerchant.merchant
      this.merchantEmail = userMerchant.email
      this.loadMerchantData()
    } else {
      const user = JSON.parse(localStorage.getItem('merchant'))
      this.merchantID = user.id
      this.merchantName = user.name
      this.merchantStatus = user.status
      this.merchantCashOnDeliveryFees = user.cash_processing_fees
      this.subscriptionId = user.subscription.id
      if (this.merchantStatus === 'active') {
        this.loadPickupPoints()
      }
    }
    if (localStorage.getItem('packages') && (new Date() - new Date(JSON.parse(localStorage.getItem('packages')).time)) / (60 * 60 * 1000) <= 1) {
      this.managePackageSize(JSON.parse(localStorage.getItem('packages')).data)
    } else {
      this.loadPackagesSize()
    }
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";

.vs-con-input-label.is-label-placeholder {
  margin-top: 10px;
}
.dropdown {
  .vs-dropdown--item-link span {
    color: #0A3266 !important;
  }
}
</style>
